import React from "react";
import BaseComponent from "../../../../modules/baseComponent";
import Graph from "./graph.js";
import { totalRevenueMetricService } from "../../../../services/index";
import Utils from "../../../../utility";
import moment from "moment";

class RevenueXdc extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      oneDayData: [],
      fiveDayData: [],
      oneMonthData: [],
      oneYearData: [],
      fiveYearData: [],
      resultOneDay: [],
      resultFiveDays: [],
      resultOneMonth: [],
      resultOneYear: [],
      resultFiveYear: [],
      graphForOneday: [],
      graphForFiveDays: [],
      graphForOneMonth: [],
      graphForOneYear: [],
      graphForFiveYear: [],
    };
  }

  async componentDidMount() {
    await this.revenueMetricGraph();
  }

  async revenueMetricGraph() {
    let [error, revenueMetricGraph] = await Utils.parseResponse(
      totalRevenueMetricService.getTotalRevenueMetric()
    );
    if (error || !revenueMetricGraph) return;

    // this.setState({ revenueMetricGraph });

    this.setState({ graphForOneday: revenueMetricGraph?.oneDayData });
    this.setState({ graphForFiveDays: revenueMetricGraph?.fiveDayData });
    this.setState({ graphForOneMonth: revenueMetricGraph?.oneMonthData });
    this.setState({ graphForOneYear: revenueMetricGraph?.oneYearData });
    this.setState({ graphForFiveYear: revenueMetricGraph?.forFiveYear });

    // ----------OneDay---------------
    var oneDayArray = [
      {
        id: "Revenue Metric One-Day-graph",
        data: [],
      },
    ];
    var oneDayResult = [];

    let newOneDayData = this.state.graphForOneday.sort(
      (a, b) => a?._id?.day - b?._id?.day
    );

    newOneDayData.map((items, index) => {
      let oneDayTime = moment(items._id.day).format("llll");
      let oneDayRevenue = items.totalRevenue;
      oneDayResult.push({
        x: oneDayTime,
        y: oneDayRevenue,
      });
    });
    // let graphdata = oneDayResult;
    oneDayArray[0].data = oneDayResult;
    this.setState({ oneDayData: oneDayResult.length });
    this.setState({ resultOneDay: oneDayArray });

    // -----------FiveDay--------------

    var fiveDaysArray = [
      {
        id: "Revenue Metric Five-Day-graph",
        data: [],
      },
    ];
    var fiveDaysResult = [];

    let newFiveDaysData = this.state.graphForFiveDays.sort(
      (a, b) => a?._id?.day - b?._id?.day
    );

    newFiveDaysData.map((items, index) => {
      let fiveDayTime = moment(items._id.day).format("llll");
      let fiveDayRevenueXdc = items.totalRevenue;
      fiveDaysResult.push({
        x: fiveDayTime,
        y: fiveDayRevenueXdc,
      });
    });
    // let graphdata = fiveDaysResult;
    fiveDaysArray[0].data = fiveDaysResult;
    this.setState({ fiveDayData: fiveDaysResult.length });
    this.setState({ resultFiveDays: fiveDaysArray });

    // -----------OneMonth--------------

    var oneMonthArray = [
      {
        id: "Revenue Metric One-Month-graph",
        data: [],
      },
    ];
    var oneMonthResult = [];

    let newOneMonthData = this.state?.graphForOneMonth?.sort(
      (a, b) => a?._id?.day - b?._id?.day
    );

    newOneMonthData &&
      newOneMonthData.length >= 1 &&
      newOneMonthData.map((items, index) => {
        let oneMonthTime = moment(items._id.day).format("lll");
        let oneMonthRevenueXdc = items.totalRevenue;
        oneMonthResult.push({
          x: oneMonthTime,
          y: oneMonthRevenueXdc,
        });
      });
    oneMonthArray[0].data = oneMonthResult;
    this.setState({ oneMonthData: oneMonthResult.length });
    this.setState({ resultOneMonth: oneMonthArray });

    // -----------OneYear--------------

    var oneYearArray = [
      {
        id: "Revenue Metric One-Year-graph",
        data: [],
      },
    ];
    var oneYearResult = [];

    let newOneYearData = this.state?.graphForOneYear?.sort(
      (a, b) => a?._id?.day - b?._id?.day
    );

    newOneYearData &&
      newOneYearData.length >= 1 &&
      newOneYearData.map((items, index) => {
        let oneYearTime = moment(items._id.day).format("lll");
        let oneYearRevenue = items.totalRevenue;
        oneYearResult.push({
          x: oneYearTime,
          y: oneYearRevenue,
        });
      });
    // let graphdata = oneYearResult;
    oneYearArray[0].data = oneYearResult;
    this.setState({ oneYearData: oneYearResult.length });
    this.setState({ resultOneYear: oneYearArray });

    // -----------FiveYear--------------

    var FiveYearArray = [
      {
        id: "Revenue Metric Five-Year-graph",
        data: [],
      },
    ];
    var fiveYearResult = [];

    let newFiveYearData = this.state.graphForFiveYear.sort(
      (a, b) => a?._id?.day - b?._id?.day
    );

    newFiveYearData.map((items, index) => {
      let fiveYearTime = moment(items._id.day).format("lll");
      let fiveYearRevenue = items.totalRevenue;
      fiveYearResult.push({
        x: fiveYearTime,
        y: fiveYearRevenue,
      });
    });
    // let graphdata = fiveYearResult;
    FiveYearArray[0].data = fiveYearResult;
    this.setState({ fiveYearData: fiveYearResult.length });
    this.setState({ resultFiveYear: FiveYearArray });
  }

  render() {
    return (
      <Graph
        oneDayDataLength={this.state.oneDayData}
        fiveDayDataLength={this.state.fiveDayData}
        oneMonthDataLength={this.state.oneMonthData}
        oneYearDataLength={this.state.oneYearData}
        fiveYearDataLength={this.state.fiveYearData}
        oneDayData={this.state.resultOneDay}
        fiveDayData={this.state.resultFiveDays}
        oneMonthData={this.state.resultOneMonth}
        oneYearData={this.state.resultOneYear}
        fiveYearData={this.state.resultFiveYear}
      />
    );
  }
}

export default RevenueXdc;
